import React, { Component } from "react";
import { ajaxManage, unparam } from "utils/common";
//css
import "../bind/index.less";
//https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd0c4bfd889805b2d&redirect_uri=http%3A%2F%2F192.168.0.211%2Fcreate&response_type=code&scope=snsapi_base&state=123#wechat_redirect

class App extends Component {
	state = {
		msg: "",
		qrcodeUrl: ""
	}

	componentDidMount(){
        document.title = "快速创建视频面试账号"
        //获取页面参数
        const queryString = unparam(window.location.search);

        ajaxManage({
			url: "/account/addAccount",
			data: {
				code: queryString.code
			}
		}).then(res => {
			this.setState({
				msg: "识别二维码进入视频面试：",
				qrcodeUrl: "data:img/png;base64," + res.data
			})
		}).catch(err => {
			this.setState({
				msg: "创建账号失败！"
			})
		})
	}

  	render() {
  		const { msg, qrcodeUrl } = this.state;
    	return (
    		<div className="bind-wrap">
    			<h1 className="bind-title">{ msg }</h1>
    			<img src={ qrcodeUrl } className="bind-qrcode" />
    		</div>
		);
	}
}

export default App;